import React from "react";
import { useNavigate } from 'react-router-dom';
import logo from '../Images/logo.png'; // Your logo image path
import cartIcon from '../Images/bag-happy.png'; // Your cart icon path (from image provided)
import { Link } from 'react-router-dom';

const Header = () => {

    const navigate = useNavigate();

    const handleCartClick = () => {
        navigate('/Cart'); // Navigate to /Cart route
      };


  return (
    <header className="bg-white p-4 flex justify-between items-center  px-4 xl:px-0  border-b border-gray-300 z-20 relative max-w-screen-xl mx-auto  relative">
      {/* Left Section: Logo and My Account */}
      <div className="flex items-center">
        {/* Logo */}
        <Link to="/">
        <img src={logo} alt="PrintTrio Logo" className="h-8 w-auto mr-2" />
        </Link>
        {/* Vertical Divider */}
        <div className="h-6 border-l border-gray-300 mx-3"></div>

        {/* My Account Text */}
        <span className="text-gray-800 font-semibold">My Account</span>
      </div>

      {/* Right Section: Return to Shop Link and Cart Icon */}
      <div className="flex items-center space-x-6">
        {/* Return to Shop Link */}
        <a href="/" className="text-pink-500 hover:text-pink-600 text-sm font-semibold">
          Return to shop
        </a>

        {/* Cart Icon */}
        <img src={cartIcon} alt="Cart Icon" className="h-5 w-5 cursor-pointer"  onClick={handleCartClick}/>
      </div>
    </header>
  );
};

export default Header;
